// AUTO-GENERATED from docs/TECHNICAL_PRD.md — CID Agent PWA API layer
// Module: Home dashboard (agent PWA) — caller-scoped read models under /api/agent/home/*
// Every list (collection GET) takes params { page, limit, ...filters }.
import client from './client';

/**
 * GET /api/agent/home/summary [LIST · paginated]
 * Single composite hero payload the home screen loads first: GCI+tier, commission rollup, this-month closings, leaderboard rank, action-needed count.
 * @disposition BUILD_NEW · maps to NEW (loosely GET /dashboard/stats, which is branch-scoped and not caller-safe)
 */
export const listHomeSummary = (params = {}) => client.get(`/api/agent/home/summary`, { params });

/**
 * GET /api/agent/home/gci [LIST · paginated]
 * GCI + tier ladder detail for the progress ring: YTD, lifetime, current tier %, next tier %, RM-to-next-tier, in-year progress since 85%.
 * @disposition BUILD_NEW · maps to NEW (fields exist on GET /agents/:id but that endpoint is admin-only and returns governance fields)
 */
export const listHomeGci = (params = {}) => client.get(`/api/agent/home/gci`, { params });

/**
 * GET /api/agent/home/commissions/summary [LIST · paginated]
 * Caller's released / pending / paid / awaiting-payout commission totals across all their sales, broken down by commission_type.
 * @disposition BUILD_NEW · maps to ADAPT of sale.service.listCommissions (GET /sales/:id/commissions) and payout.service.listCommissionsForLedger — both currently return ALL recipients (leak)
 */
export const listHomeCommissionsSummary = (params = {}) => client.get(`/api/agent/home/commissions/summary`, { params });

/**
 * GET /api/agent/home/leaderboard-rank [LIST · paginated]
 * Caller's leaderboard position instead of the full roster: my rank, total participants, percentile, optional masked neighbors.
 * @disposition ADAPT_SCOPE · maps to GET /dashboard/top-agents (same ordering by current_year_gci, but returns full roster with each agent's GCI)
 */
export const listHomeLeaderboardRank = (params = {}) => client.get(`/api/agent/home/leaderboard-rank`, { params });

/**
 * GET /api/agent/home/closings [LIST · paginated]
 * This-month closings for the caller: count, gross total, GCI recognized, and the list of closed deals.
 * @disposition ADAPT_SCOPE · maps to GET /dashboard/recent-sales (unfiltered by caller; branch-scoped only)
 */
export const listHomeClosings = (params = {}) => client.get(`/api/agent/home/closings`, { params });

/**
 * GET /api/agent/home/action-needed [LIST · paginated]
 * Actionable items requiring the caller: REN expiry, rejected form/letter/listing, unsigned form awaiting the caller to drive signing.
 * @disposition BUILD_NEW · maps to NEW (getStats returns pending counts but org/branch-wide, not caller-owned)
 */
export const listHomeActionNeeded = (params = {}) => client.get(`/api/agent/home/action-needed`, { params });

/**
 * GET /api/agent/home/activity [LIST · paginated]
 * Recent-activity feed: chronological stream of the caller's own events (sale converted/completed, form submitted/rejected/signed, listing created/activated, letter verified/rejected, commission released/paid).
 * @disposition BUILD_NEW
 */
export const listHomeActivity = (params = {}) => client.get(`/api/agent/home/activity`, { params });
